module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.976649f5.ttf";